import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV4() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1190">
      <HeroSection data-id="element-1191" />
      <PainSection data-id="element-1192" />
      <TruthSection data-id="element-1193" />
      <ProductPresentation data-id="element-1194" />
      <ContentBreakdown data-id="element-1195" />
      <BenefitsSection data-id="element-1196" />
      <TestimonialsSection data-id="element-1197" />
      <ForYouSection data-id="element-1198" />
      <GuaranteeSection data-id="element-1199" />
      <BonusSection data-id="element-1200" />
      <ValueStack basePrice={18.9} popupStrikethroughPrice="$30.88 USD" popupSpecialPrice="$27.29 USD" data-id="element-1201" />
      <FAQSection data-id="element-1202" />
      <ImpactPhrases data-id="element-1203" />
      <Footer data-id="element-1204" />
    </div>;
}